import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

// views
import {
  IndexApp,
  Dashboard,
  Error404View
} from '@/views'

// routes
import AuthRoutes from './authRouter'
import EmployeesRouter from './employeesRouter'
import configRouter from './configRouter'
import assistanceRouter from './assistanceRouter'
import dailycontrolsRouter from './dailycontrolRouter'
import taskSheetRouter from './taskSheetRouter'
import workSheetsRouter from './workSheetsRouter'
import pieceworkRouter from './pieceworkRouter'
import reportRouter from './reportsRouter'
import workSheetMonthlyRouter from './workSheetMonthly'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '',
    redirect: 'dashboard',
    name: 'index'
  },
  {
    path: '/',
    redirect: 'dashboard',
    name: 'home',
    component: IndexApp,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          requiresVisitor: false,
          requiresAuth: true,
          title: 'Dashboard'
        }
      },
      ...configRouter,
      ...EmployeesRouter,
      ...AuthRoutes,
      ...assistanceRouter,
      ...dailycontrolsRouter,
      ...taskSheetRouter,
      ...workSheetsRouter,
      ...pieceworkRouter,
      ...reportRouter,
      ...workSheetMonthlyRouter,
      {
        path: '*',
        component: Error404View,
        meta: {
          requiresAuth: true,
          requiresVisitor: false,
          title: 'Error'
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
